export const RouteDeleteMerchflows_merchflowId_ = "/merchflows/:merchflowId";

export interface ParamsDeleteMerchflows_merchflowId_ {
  merchflowId: string;
}

export interface QueryDeleteMerchflows_merchflowId_ {
  confirmDeliveryHistoryLoss?: string;
}

export type ResponseDeleteMerchflows_merchflowId_ =
  { status: "deleted" } | { status: "confirmation_required"; deliveryCount: number };
